import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_campaign_message_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid : fromDatatype.GuidDataFieldInterface;
  message_hdr_guid : fromDatatype.GuidDataFieldInterface;
  campaign_line_guid : fromDatatype.GuidDataFieldInterface;
  message_line_guid : fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  link_type : fromDatatype.GuidDataFieldInterface;
  descr : fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  log_json : fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_dgmkt_campaign_message_link_RowClass implements bl_dgmkt_campaign_message_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    campaign_hdr_guid : fromDatatype.GuidDataFieldInterface;
    message_hdr_guid : fromDatatype.GuidDataFieldInterface;
    campaign_line_guid : fromDatatype.GuidDataFieldInterface;
    message_line_guid : fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    link_type : fromDatatype.GuidDataFieldInterface;
    descr : fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    log_json : fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    date_created: fromDatatype.TimestampTzDatatypeInterface;
    date_updated: fromDatatype.TimestampTzDatatypeInterface;
}
